import script from "./PageInDevelopment.vue?vue&type=script&setup=true&lang=ts"
export * from "./PageInDevelopment.vue?vue&type=script&setup=true&lang=ts"

import "./PageInDevelopment.vue?vue&type=style&index=0&id=4f6bf50a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f6bf50a"]])

export default __exports__